// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legal_term_snippet-module__seeMore--2EQnY{text-align:center}.legal_term_snippet-module__button--1nFCd{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;margin:16px auto;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#36b}\n", ""]);
// Exports
exports.locals = {
	"seeMore": "legal_term_snippet-module__seeMore--2EQnY",
	"button": "legal_term_snippet-module__button--1nFCd"
};
module.exports = exports;
